export default __webpack_public_path__ + "static/media/logo.7e696eda.svg";